export default __webpack_public_path__ + "static/media/colors-1024w.1e4a127e.avif";